<template>
  <div class="event-component">
    <h3>{{ name }} {{ date }}</h3>
    <v-select
      :items="items"
      :value="value"
      @change="updateSelectedValue"
      class="input-group--focused"
      :hint="currentHint"
      :persistent-hint="currentHint.length > 0"
      :disabled="birthday.length === 0"
      required
      :rules="nameRules"
    ></v-select>
    <v-checkbox :label="discountMultipleDogsLabel" :readonly="true"
                v-if="discountMultipleDogsEnabled" :input-value="hasDiscountMultipleDogs"></v-checkbox>

  </div>
</template>

<script>
// import Vue from 'vue';
import moment from 'moment';
import 'moment/min/locales';
import EventComponentItem from './EventComponentItem';

export default {
  components: {
    EventComponentItem,
  },
  name: 'event-component',
  data() {
    return {
      selectedItem: null,
      nameRules: [
        v => !!v || this.$t('Required'),
      ],
      breeder_group: false,
    };
  },
  props: {
    value: {
      type: String,
    },
    birthday: {
      type: String,
    },
    name: {
      type: String,
    },
    date: {
      type: String,
    },
    calculationDate: {
      type: String,
    },
    choices: {
      type: Array,
    },
    discountMultipleDogs: {
      type: Boolean,
    },
    discountMultipleDogsEnabled: {
      type: Boolean,
    },
  },
  watch: {
    selectedItem(value) {
      this.$emit('update', value);
    },
  },
  computed: {
    discountMultipleDogsLabel() {
      // eslint-disable-next-line max-len
      return `${this.$t('For every additional dog of the same owner (Except baby and puppy class)')}: -${this.formatCurrency(this.$config.discount.multipleDogs)}`;
    },
    currentHint() {
      const choice = this.choices.find(c => c.keyword === this.value);
      return choice && choice.hint ? choice.hint : '';
    },
    items() {
      return this.choices.map(choice => ({
        text: this.getTitleChoice(choice),
        disabled: !this.itemIsValid(choice),
        value: choice.keyword,
      }));
    },
    difference() {
      return moment(this.calculationDate).diff(this.birthday, 'months', true);
    },
    hasDiscountMultipleDogs() {
      const choice = this.choices.find(c => c.keyword === this.value);
      if (!choice) return false;
      console.log(this.discountMultipleDogs, this.discountMultipleDogsEnabled, choice.discountMultipleDogs);
      const result = this.discountMultipleDogs && this.discountMultipleDogsEnabled && choice.discountMultipleDogs;
      return result;
    },
  },
  methods: {
    formatCurrency(num) {
      // Create our number formatter.
      const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        // the default value for minimumFractionDigits depends on the currency
        // and is usually already 2
      });
      return formatter.format(num / 100);
    },
    updateSelectedValue(value) {
      this.selectedItem = value;
      this.$emit('update', value);
    },
    itemIsValid(choice) {
      if (!choice.max && !choice.min) {
        return true;
      }

      const from = moment(this.calculationDate).subtract(choice.max, 'months').add(1, 'day');
      const birthday = moment(this.birthday);
      const to = moment(this.calculationDate).subtract(choice.min, 'months');
      const meetsMaximum = birthday >= from;
      const meetsMinimum = birthday <= to;

      if (!choice.max) {
        return meetsMinimum;
      }
      if (!choice.min) {
        return meetsMaximum;
      }
      return meetsMinimum && meetsMaximum;
    },

    getTitleChoice(choice) {
      let monthString = '';
      let months = this.$t('months');
      const showYear = choice.min > 30;
      let min = choice.min;
      if (showYear) {
        months = this.$t('year');
        min /= 12;
      }
      if (!choice.max && !choice.min) {
        monthString = '';
      } else if (!choice.max) {
        monthString = `> ${min} ${months}`;
      } else if (!choice.min) {
        monthString = `< ${choice.max} ${months}`;
      } else {
        monthString = `${choice.min} - ${choice.max} ${months}`;
      }
      if (monthString.length > 0) {
        monthString = `(${monthString})`;
      }
      let costString = '';
      // eslint-disable-next-line max-len
      const hasMultipleDogDiscount = this.discountMultipleDogs && this.discountMultipleDogsEnabled && choice.discountMultipleDogs;

      if (choice.cost) {
        let optionCost = choice.cost;
        if (hasMultipleDogDiscount) {
          optionCost -= this.$config.discount.multipleDogs;
        }
        // Create our number formatter.
        const formatter = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR',
        });
        costString = formatter.format(optionCost / 100);
      }
      return `${choice.title} ${costString}`;
    },
    between(a, b) {
      return this.difference >= a && this.difference <= b;
    },
    olderThan(a) {
      return this.difference >= a;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .event-component {
    margin-left: 10px;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/EventComponent.vue